
import {createSlice} from "@reduxjs/toolkit";

export const externalDataSlice = createSlice({
    name: 'externalDataSnackbarSlc',
    initialState: {value: {snackbarOpen: false, snackbarSeverity: "", snackbarMessage: "",
        submitting: false, submitSuccess: false, submitError: false}},
    reducers:
        {
            changeExternalData: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeExternalData } = externalDataSlice.actions;

export default  externalDataSlice.reducer ;


